export default function DetailedStats({ stats, isLoading }) {
  const metrics = [
    {
      label: 'Prospects avec email',
      value: stats.prospectsWithEmail || 0,
      percentage: stats.totalProspects > 0 ? Math.round((stats.prospectsWithEmail / stats.totalProspects) * 100) : 0,
    },
    {
      label: 'Prospects avec téléphone',
      value: stats.prospectsWithPhone || 0,
      percentage: stats.totalProspects > 0 ? Math.round((stats.prospectsWithPhone / stats.totalProspects) * 100) : 0,
    },
    {
      label: 'Crédits utilisés (total)',
      value: stats.totalCreditsUsed || 0,
      percentage: Math.min(((stats.totalCreditsUsed || 0) / 1000) * 100, 100),
    },
    {
      label: 'Recherches cette semaine',
      value: stats.recentSearchesCount || 0,
      percentage: Math.min(((stats.recentSearchesCount || 0) / 10) * 100, 100),
    },
  ]

  return (
    <div className="performance-card">
      <div className="card-header">
        <h2>Statistiques détaillées</h2>
      </div>
      <div className="performance-metrics">
        {metrics.map((metric, i) => (
          <div key={i} className="metric">
            <div className="metric-label">{metric.label}</div>
            <div className="metric-value">{isLoading ? '-' : metric.value.toLocaleString('fr-FR')}</div>
            <div className="metric-bar">
              <div className="bar-fill" style={{ width: `${metric.percentage}%` }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
